import React from 'react'
import PropTypes from 'prop-types'

class CustomCheckbox extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isChecked: this.props.isChecked,
    }

    this.onCheckboxChange = this.onCheckboxChange.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isChecked !== this.props.isChecked) {
      this.setState({ isChecked: this.props.isChecked })
    }
  }

  onCheckboxChange() {
    this.setState(prevState => ({
      isChecked: !prevState.isChecked,
    }))

    this.props.onTrigger(this.props.name, !this.state.isChecked)
  }

  render() {
    const className = this.state.isChecked ? `btn-${this.props.color}` : 'btn-outline-default'

    return (
      <label className={`btn-checkbox ${this.props.hasNoTransition ? 'btn-checkbox--without-transition' : ''}`}>
        <input type="checkbox" className="is-hidden" name={this.props.name} onChange={this.onCheckboxChange} disabled={this.props.isDisabled} />
        <span className={`btn ${className} ${this.props.customClass} ${this.props.isDisabled && 'is-disabled'}`}>{this.props.text}</span>
      </label>
    )
  }
}

CustomCheckbox.propTypes = {
  text: PropTypes.string.isRequired,
  name: PropTypes.string,
  color: PropTypes.string,
  customClass: PropTypes.string,
  isDisabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  onTrigger: PropTypes.func.isRequired,
  hasNoTransition: PropTypes.bool,
}

CustomCheckbox.defaultProps = {
  name: '',
  isDisabled: false,
  isChecked: false,
  color: 'dark',
  customClass: '',
  hasNoTransition: false,
}

export default CustomCheckbox
